import { GolfIcon } from './GolfIcon';

/**
 * author: Google
 * id 80A4F47A-3512-4C76-AA10-C0232C57E624
 * name golf
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/golf.svg
 * tags
 * - Sport 
 */
export const GolfCourseIcon = GolfIcon;
export default GolfCourseIcon